import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import {isExperiment} from '../config';
import {transformForMenu} from '../services/category-transformer';
import {execBI} from '../services/bi-events-manager';
import {popupHide} from '../actions/popup';
import ALink from './ALink';


class CategoriesMenu extends React.Component {

  linkClick(slug) {
    return () => {
      execBI('CATEGORY_LINK_CLICK', {category: slug, origin: 'menu'});
    };
  }

  /**
   * Close popup when clicking on link or outside menu
   * Can't use regular overlay behind because we need interactive elements outside
   */
  componentWillUpdate(nextProps) {
    if (nextProps.isVisible && this.props.isVisible !== nextProps.isVisible) {
      const root = document.getElementById('app-market');

      const closeMenu = (ev) => {
        const findTarget = (el) => {
          if (['A', 'INPUT', 'BUTTON'].indexOf(el.tagName) !== -1 || el === root) {
            root.removeEventListener('click', closeMenu);

            if (el.id !== 'app-market-categories-button') {
              this.props.dispatch(popupHide());
            }

          } else if (el !== this.container) {
            findTarget(el.parentElement);
          }
        };

        findTarget(ev.target);
      };

      root.addEventListener('click', closeMenu);
    }
  }

  render() {
    const openCategory = this.props.openCategory;
    const isMyApps = isExperiment('specs.market.EditorMyAppsPage', this.props.experiments) || this.props.pending.length || this.props.developer.length;
    const categories = transformForMenu(this.props.categories);

    return (
      <div className={classNames('categories-menu-container', {'categories-menu-visible': this.props.isVisible})}>
        <div className={classNames('categories-menu', {'categories-menu-no-my-apps': !isMyApps})} ref={i => this.container = i}>
          <div className="categories-menu-wrapper">
            <div className="categories-menu-flex">

              <div className="category-1-4">
                <h4 className="category-title typography_t3_1"><FormattedMessage id="category.more.tools"/></h4>
                <ul className="category-list">
                  {categories.filter((c) => c.label === 'more').map((c) =>
                    <li key={c.slug} className={classNames('category-item', 'typography_t2', {'selected': c.slug === openCategory})}>
                      <ALink to={`/${c.slug}/`} onClick={this.linkClick(c.slug)}>{c.name}</ALink>
                    </li>
                  )}
                </ul>
              </div>

              <div className="category-1-4">
                <h4 className="category-title typography_t3_1"><FormattedMessage id="category.business.apps"/></h4>
                <ul className="category-list">
                  {categories.filter((c) => c.label === 'business').map((c) =>
                    <li key={c.slug} className={classNames('category-item', 'typography_t2', {'selected': c.slug === openCategory})}>
                      <ALink to={`/${c.slug}/`} onClick={this.linkClick(c.slug)}>{c.name}</ALink>
                    </li>
                  )}
                </ul>
              </div>

              <div className="category-1-4">
                <h4 className="category-title typography_t3_1"><FormattedMessage id="category.browse.apps"/></h4>
                <ul className="category-list">
                  {categories.filter((c) => c.label === 'browse' && !(this.props.market === 'standalone' && c.slug === 'all-apps')).map((c) =>
                    <li key={c.slug} className={classNames('category-item', 'typography_t2', {'selected': c.slug === openCategory})}>
                      <ALink to={`/${c.slug}/`} onClick={this.linkClick(c.slug)}>{c.name}</ALink>
                    </li>
                  )}
                </ul>
              </div>

              <div className="category-1-4 category-my">
                <h4 className="category-title typography_t3_1"><FormattedMessage id="category.myApps.name"/></h4>
                <ul className="category-list">
                  {isExperiment('specs.market.EditorMyAppsPage', this.props.experiments) ?
                    <li className={classNames('category-item', 'typography_t2', {'selected': openCategory === 'my-apps'})}>
                      <ALink to={'/my-apps/'} onClick={this.linkClick('my-apps')}>
                        <FormattedMessage id="category.installed.apps"/> (5)
                      </ALink>
                    </li> : null}

                  {this.props.pending.length ?
                    <li className={classNames('category-item', 'typography_t2', {'selected': openCategory === 'pending-apps'})}>
                      <ALink to={'/pending/'} onClick={this.linkClick('pending-apps')}>
                        <FormattedMessage id="category.pending.name"/>
                        <span className="categories-notification">{this.props.pending.length}</span>
                      </ALink>
                    </li> : null }

                  {this.props.developer.length ?
                    <li className={classNames('category-item', 'typography_t2', {'selected': openCategory === 'developer-apps'})}>
                      <ALink to={'/developer/'} onClick={this.linkClick('developer-apps')}>
                        <FormattedMessage id="category.developerApps.name"/>
                      </ALink>
                    </li> : null }
                </ul>
              </div>
            </div>

            {this.props.market === 'standalone' ?
              <div className={classNames('categories-menu-main-page typography_t2', {'selected': openCategory === 'main'})}>
                <ALink to={'/main'} onClick={this.linkClick('main-page')}><FormattedMessage id="category.all.name"/></ALink>
              </div> :
              <div className={classNames('categories-menu-main-page typography_t2', {'selected': !openCategory})}>
                <ALink to={'/'} onClick={this.linkClick('main-page')}><FormattedMessage id="category.mainPage.name"/></ALink>
              </div>}

          </div>
        </div>

      </div>
    );
  }

  static propTypes = {
    categories: PropTypes.array,
    developer: PropTypes.array,
    pending: PropTypes.array,
    isVisible: PropTypes.bool,
    dispatch: PropTypes.func,
    openCategory: PropTypes.string,
    market: PropTypes.string,
    experiments: PropTypes.object
  };
}

function mapStateToProps(state) {
  return {
    categories: state.categories.menu.items,
    developer: state.appsByType.developer.items,
    pending: state.appsByType.pendingInMarket.items,
    openCategory: state.categories.openCategory,
    isVisible: state.popup.type === 'menu',
    market: state.mode.market,
    experiments: state.mode.experiments
  };
}

export default connect(mapStateToProps)(CategoriesMenu);



// WEBPACK FOOTER //
// ./components/Categories-menu.js